import { isNotEmpty } from '@doltech/utils/lib/text';
import { isNil } from 'lodash';
import { getSnapshot, types as t } from 'mobx-state-tree';

import {
  ListeningExplanationStore,
} from '../../../../../question-data-model/Explanation/_extends/listening-explanation.store';
import { AdminExplanationStore } from '../admin-explanation.store';

interface SyncListeningDetailInput {
  startTimeInSeconds: number;
  endTimeInSeconds: number;
  transcripts: any;
}

export const AdminListeningExplanationStore = t
  .compose(ListeningExplanationStore, AdminExplanationStore)
  .named('AdminListeningExplanationStore')
  .views((self) => ({
    get isCompleted(): boolean {
      return (
        isNil(self.startTimeInSeconds) === false &&
        isNil(self.endTimeInSeconds) === false &&
        isNotEmpty(self.detailExplanation)
      );
    },
    get isDirty(): boolean {
      return (
        isNil(self.startTimeInSeconds) === false ||
        isNil(self.endTimeInSeconds) === false ||
        isNotEmpty(self.detailExplanation)
      );
    },
  }))
  .actions((self) => ({
    init() {},
    sync(input: SyncListeningDetailInput) {
      const { startTimeInSeconds, endTimeInSeconds, transcripts } = input;
      self.startTimeInSeconds = startTimeInSeconds;
      self.endTimeInSeconds = endTimeInSeconds;
      self.transcripts = transcripts.map((item) => {
        return {
          ...item,
          character: item.character ? getSnapshot(item.character) : null,
        };
      });
    },
  }));

